module.exports = __webpack_public_path__ + "static/media/ups-logo.ee435073.svg";